import styled from "styled-components";

export const FormRow = styled.div`
  padding-bottom: 10px;

  // Date picker is not sitting flush within modal
  // due to issues with popper and its placemenet.
  .react-datepicker-popper {
    inset: unset !important;
    transform: none !important;
    left: 0;
    bottom: 25px !important;
  }

  // Prevents time section from wrapping to below date section on narrow viewports
  @media (max-width: 380px) {
    .react-datepicker__time-container {
      width: 70px;
    }

    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box {
      width: 70px;
    }
  }
`;

export const ModalBodyWrapper = styled.div`
  word-break: break-word;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
